export default __webpack_public_path__ + "static/media/Revised.0888264c.pdf";